export default function SoftwareEngineerForm() {
  return (
    <div className="job-form-container">
      <h1>Apply – Software Engineer</h1>
      <p>Technology & platform development</p>

      <div className="job-form-grid">
        <input placeholder="Full Name" />
        <input placeholder="Email Address" />
        <input placeholder="Primary Tech Stack (React, Node, etc.)" />
        <input placeholder="Years of Experience" />
        <input placeholder="GitHub / Portfolio Link" />
        <textarea placeholder="Brief About Your Projects" />
      </div>

      <button>Submit Application</button>
    </div>
  );
}
